export enum BuilderItemDragTypeEnum {
  item = 'item',
  builderItem = 'builderItem',
  sessionItem = 'sessionItem',
  sessionResourceItem = 'sessionResourceItem',
  sessionInstrumentItem = 'sessionInstrumentItem',
}
